import clsx from "clsx";
import {
  Activity,
  AirVent,
  BatteryCharging,
  BellRing,
  Building,
  Building2,
  CircuitBoard,
  ClipboardCheck,
  CloudLightning,
  DoorOpen,
  Flame,
  Gauge,
  Handshake,
  House,
  KeyRound,
  Landmark,
  PlugZap,
  ShieldCheck,
  Snowflake,
  Sun,
  Thermometer,
  ThermometerSun,
  Wind,
} from "lucide-react";
import type { ComponentType } from "react";
import { NavItem, NavItemProps } from "~/components/NavItem";
import { NAV_LABELS } from "~/content/Labels";
import { ROUTES } from "~/content/Routes";
import {
  SERVICE_NAV_GROUPS,
  type ServiceNavIcon,
} from "~/content/serviceNavigation";

const SERVICE_ICON_MAP: Record<ServiceNavIcon, ComponentType<{ className?: string }>> = {
  "plug-zap": PlugZap,
  "gauge": Gauge,
  "cloud-lightning": CloudLightning,
  "sun": Sun,
  "battery-charging": BatteryCharging,
  "circuit-board": CircuitBoard,
  "flame": Flame,
  "activity": Activity,
  "thermometer": Thermometer,
  "clipboard-check": ClipboardCheck,
  "wind": Wind,
  "air-vent": AirVent,
  "snowflake": Snowflake,
  "thermometer-sun": ThermometerSun,
  "bell-ring": BellRing,
  "shield-check": ShieldCheck,
  "door-open": DoorOpen,
  "building-2": Building2,
};

const navItems: NavItemProps[] = [
  ...SERVICE_NAV_GROUPS.map((group) => ({
    name: group.heading,
    subItems: group.links.map((link) => {
      const Icon = SERVICE_ICON_MAP[link.icon];
      return {
        name: link.label,
        href: link.href,
        icon: <Icon className="h-6 w-6" />,
      };
    }),
  })),
  {
    name: NAV_LABELS.SOLUTIONS,
    subItems: [
      {
        name: NAV_LABELS.FOR_PROPERTY_MANAGERS,
        href: ROUTES.PROPERTY_MANAGERS,
        icon: <Building className="h-6 w-6" />,
      },
      {
        name: NAV_LABELS.FOR_LANDLORDS,
        href: ROUTES.LANDLORDS,
        icon: <KeyRound className="h-6 w-6" />,
      },
      {
        name: NAV_LABELS.FOR_BUILDING_MANAGERS,
        href: ROUTES.BUILDING_MANAGERS,
        icon: <Landmark className="h-6 w-6" />,
      },
      {
        name: NAV_LABELS.FOR_HOMEOWNERS,
        href: ROUTES.HOMEOWNERS,
        icon: <House className="h-6 w-6" />,
      },
      {
        name: NAV_LABELS.FOR_REAL_ESTATE,
        href: ROUTES.REAL_ESTATE,
        icon: <Handshake className="h-6 w-6" />,
      },
    ],
  },
  {
    name: NAV_LABELS.BLOG,
    href: ROUTES.BLOG,
  },
  {
    name: NAV_LABELS.ABOUT_US,
    href: ROUTES.ABOUT_US,
  },
];

type Props = {
  className?: string;
};

const Nav: React.FC<Props> = ({ className }) => {
  return (
    <nav className={clsx("flex", className)}>
      {navItems.map((item) => (
        <NavItem key={item.name} {...item} />
      ))}
    </nav>
  );
};

export { Nav };
